import type { AccountState, PlanType } from "./api";

export function isPaidPlan(accountState: AccountState | null | undefined): boolean {
  return (accountState?.plan === "paid" || accountState?.plan === "executive")
    && accountState?.entitlementStatus === "active";
}

export function isExecutivePlan(accountState: AccountState | null | undefined): boolean {
  return accountState?.plan === "executive" && accountState?.entitlementStatus === "active";
}

export function canUpgradeToPaid(accountState: AccountState | null | undefined): boolean {
  if (!accountState) return false;
  const plan: PlanType = accountState.plan;
  return plan === "free" || plan === "invite_trial" || plan === "none";
}

export function isBillingErrorCode(value: unknown): value is "billing_subscription_already_active" | "billing_customer_not_found" {
  return value === "billing_subscription_already_active" || value === "billing_customer_not_found";
}
